export default __webpack_public_path__ + "f2df5f1bf834b13c0287572db50e7ec7.png";